import classNames from 'classnames'
import { Dispatch, SetStateAction } from 'react'

export const OptionsTabs: React.FC<{
  options: string[]
  currentIndex: number
  setCurrentIndex: Dispatch<SetStateAction<number>>
  onChange?: (index: number) => void
}> = ({ options, currentIndex, setCurrentIndex, onChange }) => {
  return (
    <div className="flex items-center mb-4 border-b-[1px] border-neutral-300 overflow-x-auto scrollbar-hidden">
      {options.map((item, index) => {
        const isActive = currentIndex === index
        return (
          <div
            key={index}
            className={classNames(
              'relative flex-shrink-0 whitespace-nowrap px-3.5 py-2 text-sm font-semibold hover:text-neutral-900 cursor-pointer transition-all',
              [isActive ? 'text-neutral-900' : 'text-neutral-400']
            )}
            onClick={() => {
              if (isActive) return
              setCurrentIndex(index)
              onChange?.(index)
            }}
          >
            {item}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 mx-auto w-8 h-0.5 bg-primary"></span>
            )}
          </div>
        )
      })}
    </div>
  )
}
